module.exports = __webpack_public_path__ + "static/media/ETH-BNB.95352782.svg";